import EmailForm from "./components/EmailForm";

function App() {
  return (
    <div>
      <EmailForm />
    </div>
  );
}

export default App;
